import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { SnapshotResponse } from "../../../shared/response/proyectos/SnapshotResponse";
import { SnapshotPayload } from "../../../shared/services/api/payload/proyectos/SnapshotPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { SnapshotService, toSnapshotResponse } from "./SnapshotService";

/** Alta y edición de snapshots; el resultado reemplaza la fila del listado. */
export class SnapshotSaveService extends ServiceSaveBase<SnapshotResponse, SnapshotPayload> {
  protected readonly cache = SnapshotService.instance;

  /** gRPC-Web (`GuardarSnapshot`): el factor jornal lo calcula el servidor. */
  protected async sendSave(p: SnapshotPayload): Promise<SnapshotResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarSnapshot({
      id: p.id ?? undefined,
      anio: p.año,
      smmlv: BigInt(Math.round(p.smmlv)),
      subsidioTransporte: BigInt(Math.round(p.subsidioTransporte)),
      ipc: p.ipc,
      nota: p.nota ?? undefined,
    }));
    return toSnapshotResponse(r);
  }
}
